import styled, { css } from 'styled-components'

interface PriceToggleWrapperProps {
  limitWidth?: boolean
}

export const PriceToggleWrapper = styled.div<PriceToggleWrapperProps>`
  ${({ limitWidth }) =>
    limitWidth &&
    css`
      min-width: 300px;
      max-width: 600px;
    `}
`

export const PriceLockupWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-end;
  flex-wrap: wrap;
`

export const ContentWrapper = styled.div`
  padding-right: 0.3rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`

export const TextContainer = styled.div`
  margin-left: 0.6rem;
  flex: 1 1 0%;
`

export const ToggleWrapper = styled.div`
  background-color: #f4f4f7;
  padding: 1rem;
  border-radius: 7px;
`
